import api from '../../../REST/api';
import { transformForPatch } from '../transform-contact-list-helpers';

export default async function postContactList(oldContactList) {
  const contactListData = {
    ...transformForPatch(oldContactList),
    name: `Copy of ${oldContactList.name}`,
  };

  return api.addContactList({ data: contactListData });
}
